import React, { FC, PropsWithChildren } from 'react';

import { FormattedMessage } from 'react-intl';

import { Description, DescriptionContainer, GameTypeContainer, Separator } from './styles';

type GameTypeDividerProps = PropsWithChildren & {
    isStartOfGameType: boolean;
};

type SeasonDividerProps = {
    isStartOfSeason: boolean;
    isStartOfGameType: boolean;
};

const GameTypeDivider: FC<GameTypeDividerProps> = ({ children, isStartOfGameType }) => (
    <GameTypeContainer $isStartOfGameType={isStartOfGameType}>
        <Separator />
        <DescriptionContainer>
            <Description>{children}</Description>
        </DescriptionContainer>
    </GameTypeContainer>
);

export const SeasonDivider: FC<SeasonDividerProps> = ({ isStartOfSeason, isStartOfGameType }) => (
    <GameTypeDivider isStartOfGameType={isStartOfGameType}>
        {isStartOfSeason ? (
            <FormattedMessage
                description="A line divider that indicates the start of the regular season."
                defaultMessage="Start of the Regular Season"
            />
        ) : (
            <FormattedMessage
                description="A line divider that indicates the end of the regular season."
                defaultMessage="End of the Regular Season"
            />
        )}
    </GameTypeDivider>
);
